import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import { replace } from 'connected-react-router';

import routes from 'utils/routes';

import { userIsAuthenticatedRedir } from 'components/auth/hoc';
import PaymentData from 'pages/PaymentData/styled';

const enhance = compose(
  connect(() => ({}), {
    replaceRoute: replace,
  }),
  withHandlers({
    handleBack:
      ({ replaceRoute }) =>
      () =>
        replaceRoute(routes.summary),
  }),
  userIsAuthenticatedRedir
);

export default enhance(PaymentData);
